import { Answer, Question, QuestionsTypes } from '../../Types'
import { DEBUG } from '../../constants'

// Debug helper: logs a compact table of answers in chronological order to the
// browser console. Never rendered in the UI. No-op in production builds.

type DebugAssignment = { questions: Question[]; answers: Answer[] }

const truncate = (s: string, n = 14): string => (s && s.length > n ? s.slice(0, n - 1) + '…' : s ?? '')

const formatUtc = (iso: string): string => new Date(iso).toISOString().slice(11, 19)

const interpret = (question: Question, value: string, lang: string): string => {
  if (value === 'BLINDED') return 'blinded'
  if (question.type === QuestionsTypes.info) return 'viewed'
  if (question.type === QuestionsTypes.radio) {
    const idx = parseInt(value, 10)
    return question.options?.[idx]?.[lang] ?? value
  }
  if (question.type === QuestionsTypes.nprs11pt2l) {
    const idx = parseInt(value, 10)
    const intensity = (question.options as any)?.intensity
    return intensity?.[idx]?.[lang] ?? value
  }
  return value
}

export const logAssignmentDebug = (assignment: DebugAssignment, lang: string, source: string): void => {
  if (DEBUG === false) return

  const questionById = new Map(assignment.questions.map((q: Question) => [q._id, q]))
  const rows = [...assignment.answers]
    .sort((a: Answer, b: Answer) => a.createdAt.localeCompare(b.createdAt))
    .map((a: Answer) => {
      const q = questionById.get(a.questionId)
      return {
        'Time (UTC)': formatUtc(a.createdAt),
        Question: q ? truncate(q.title?.[lang] ?? '') : '?',
        Value: a.value,
        Meaning: q ? interpret(q, a.value, lang) : '',
      }
    })

  console.groupCollapsed(`[debug] ${source} — ${rows.length} answers`)
  console.table(rows)
  console.groupEnd()
}
